<template>
    <div class="div_o">
        <el-button  @click="back" slot="tt_r" type="primary" class="butn">返回</el-button>
        <div id="pay">
            <p class="pay_test pay_test_1" v-if="!verify">倒计时 <span>{{time}}</span> 秒</p>
            <img :src="'data:image/png;base64,'+code" class="avatar">
            <p class="pay_test" v-if="radio1 == '0'">使用微信扫码支付</p>
            <p class="pay_test" v-if="radio1 == '1'">使用支付宝扫码支付</p>
            <p class="pay_test" v-if="radio1 == '2'">使用银联扫码支付</p>
            <p class="pay_test pay_test_1" v-if="verify">二维码失效</p>
        </div>
    </div>

</template>

<script>
    export default {
        name: "pay_window",
        data(){
            return {
                code:this.$SIF.getLocalStorage("qrCodeBase64"),
                radio1:this.$route.params.radio1,
                id:this.$route.params.id,
                time:60,
                verify:false
            }
        },
        created() {
            // var jsonData = JSON.stringify(this.$route.query.code); // 转成JSON格式
            // // var result = $.parseJSON(jsonData);
            //
            // const div = document.createElement('div');
            // div.innerHTML = this.$route.query.code;
            // document.body.appendChild(div);
            // document.forms[0].submit();
            this.verify_num()
        },
        beforeDestroy() {
            if (this.interval) {
                clearInterval(this.interval);
            }
        },
        methods:{
            back() {
                this.$router.go(-2); //返回上一层
                if(this.$route.params.opid){
                    this.$router.push({name: 'myOrder', params:{signRule:'待支付'}})
                }
            },
            verify_num() {
                var time = this.time;
                var that = this;
                that.interval = setInterval(function() {
                    if (time <= 1) {
                        that.verify = true;
                        clearTimeout(that.interval);
                        that.$confirm('二维码失效请重新购买', '提示', {
                            confirmButtonText: '确定',
                            type: 'warning'
                        }).then(() => {
                            that.$router.go(-2); //返回上一层
                        }).catch(() => {
                            that.$router.go(-2); //返回上一层
                        });
                    } else {
                        that.$SIF.httpPost({
                            url: that.$SIF._serve.order + "/appOrderController/queryEntity",
                            data: {
                                id: that.id,
                            },
                            succFun: res => {
                                if(res.data.status ==1){
                                    clearTimeout(that.interval);
                                    that.$router.go(-3); //返回上一层
                                    that.$message({
                                        message: '购买成功',
                                        type: 'success'
                                    });
                                }
                            },failFun:res=>{
                                this.$message({
                                    message: res.msg,
                                    type: 'warning'
                                });
                            }
                        });
                        time--;
                        that.verify = false;
                        that.time = time;

                    }
                }, 1000);
            },
        }
    }
</script>

<style scoped type="text/css">
.div_o{
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
}
#pay{
    width: 100%;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}
.butn{
    margin-left: 20px;
    height: 26px;
    padding: 5px 10px;
}
.pay_test{
    color: #6A6A6A;
    font-size: 14px;
}
    .pay_test_1{
        font-size: 16px;
    }
    .pay_test_1 span{
        font-size: 18px;
        color: red;
        margin: 0 15px;
    }
</style>